import {CardBindingType, CardBoundContext} from '@yandex-delivery/api/model/payment'
import {CardBoundContextResponse} from '@yandex-delivery/api/repo/cargo-corp/types'

function toBindingType(rawType: CardBoundContextResponse['context']['binding_type']) {
  switch (rawType) {
    case 'trust':
      return CardBindingType.Trust
    case 'psp':
      return CardBindingType.Psp
    default:
      return CardBindingType.Unknown
  }
}

export function toCardBoundContext(response: CardBoundContextResponse): CardBoundContext {
  if (!response.context.binding_url) {
    throw new Error('[toCardBoundContext] empty binding_url')
  }

  return {
    bindingType: toBindingType(response.context.binding_type),
    bindingUrl: response.context.binding_url,
  }
}
